module.exports = __webpack_public_path__ + "static/media/weareallone.631e32af.png";